<template>
  <div class="lower-page business-property-edit">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('business_property_info') }}</h2>
    </div>

    <section class="wrapper">
      <div class="container-fluid">
        <suspension-notice noticeType="capacity-over" v-if="reachedLimit" />
        <div class="header d-flex justify-content-between w-100">
          <h2 v-html="$t('h2_edit-property', [$t('business-property')])"></h2>
          <router-link :to="{ name: 'business-property-list' }">
            <b-button class="px-4 py-2" variant="secondary">{{ $t('売買物件一覧') }}</b-button>
          </router-link>
        </div>
        <edit-business-property-form api-type="member" v-bind:reachedLimit="reachedLimit" v-bind:allUnpublished="allUnpublished" />
      </div>
    </section>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import editBusinessPropertyForm from '@/views/property/components/edit_business_property'
import suspensionNotice from '@/components/client/suspensionNotice'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      }
    }
  },
  components: {
    navbar,
    editBusinessPropertyForm,
    footerClient,
    suspensionNotice
  },
  created () {
    this.getReachedLimit({ id: this.$route.params.id })
  },
  computed: {
    ...mapState('properties', ['reachedLimit', 'allUnpublished'])
  },
  methods: {
    ...mapActions('properties', ['getReachedLimit'])
  }
}
</script>

<style>
.business-property-edit .header {
  margin: 40px 0;
  border-bottom: none !important;
}
.business-property-edit .header h2 {
  font-size: 2.5em;
  font-weight: bold;
  margin: 0 !important;
}
.business-property-edit .container-fluid .ml-md-auto{
  margin-left: 0 !important;
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;
}
.business-property-edit .new-property-form{
  padding: 0 !important;
}
.business-property-edit .form-input,
.business-property-edit .form-control,
.business-property-edit .custom-select,
.business-property-edit .btn-success,
.business-property-edit .btn-primary{
  font-size: 1em;
}
.business-property-edit label.required::after{
  line-height: 1;
}
.business-property-edit .btn-secondary,
.business-property-edit .btn-danger{
  font-size: 1em;
  padding: 1rem 1.5rem !important;
}
@media screen and (max-width: 768px) {
  .business-property-edit .container-fluid,
  .business-property-edit .container-fluid > div{
    padding: 0;
  }
  .business-property-edit .header {
    margin: 32px 0 24px !important;
    padding: 0 !important;
    flex-wrap: wrap;
  }
  .business-property-edit .header h2 {
    font-size: 1.75em;
    margin: 0 .5em .25em 0 !important;
  }
  .business-property-edit span.span{
    white-space: nowrap;
    padding-left: 0.5rem;
  }
  .business-property-edit .row.my-3.align-items-center.d-flex,
  .business-property-edit .d-flex.align-items-center.ml-auto.my-2.col-lg-10{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .business-property-edit .row.my-3{
    margin-bottom: 0 !important;
  }
  .business-property-edit .d-block.form-file-text{
    line-height: 1.6;
  }
  .business-property-edit .card-body.main-bg.p-0.mt-2.p-3.bg-light.text-dark{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .business-property-edit .btn-secondary{
    padding: 0.5rem 1rem !important;
  }
}
</style>
